import posed from 'react-pose';
import { keyframes } from 'styled-components';

export const FadeIn = posed.div({
  closed: {
    transform: 'scale(1.3)',
    opacity: 0,
    transition: { duration: 300 },
  },
  open: {
    transform: 'scale(1)',
    opacity: 1,
    transition: { duration: 300 },
  },
});

const animation = {
  pop: keyframes`
    0% {width: 0; height: 0;}
    12.5% {width: 0.1764rem; height: 0.1764rem;}
    25% {width: 0.3529rem; height: 0.3529rem;}
    37.5% {width: 0.5294rem; height: 0.5294rem;}
    50% {width: 0.7058rem; height: 0.7058rem;}
    62.5% {width: 1rem; height: 1rem;}
    75% {width: 0.8823rem; height: 0.8823rem;}
    87.5% {width: 0.7058rem; height: 0.7058rem;}
    100% {width: 0.7058rem; height: 0.7058rem;}
  `,
  appear: keyframes`
    0% {opacity: 0;}
    10% {opacity: .1;}
    20% {opacity: .2;}
    30% {opacity: .3;}
    40% {opacity: .4;}
    50% {opacity: .5;}
    60% {opacity: .6;}
    70% {opacity: .7;}
    80% {opacity: .8;}
    90% {opacity: .9;}
    100% {opacity: 1.0;}
  `,
};

export default animation;
